module.exports = __webpack_public_path__ + "img/project17_5.png.d1e33ec7.webp";